import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {QrCodeSettingsDefinitionDetail} from './QrCodeSettingsDefinitionDetail';

export function AccountingQrCodeSettingsEdit() {
  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.accounting.labels.qrCodeSettingsTitle'),
      href: settingsRoutes.qrCodeSettings,
    },
  ];

  const title = i18n.t('page.accounting.labels.qrCodeSettingsTitle');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{title, breadcrumbs}}
        data-testid={testIds.settings.qrCodeSettingsEdit('main')}
      >
        <QrCodeSettingsDefinitionDetail />
      </SettingsTemplate>
    </>
  );
}
